export default "__VITE_ASSET__Bksv_IFS__"